import { apiClient } from "../../../base/ApiClient";

export const getMedicalConditions = async (client_id) => {
  const response = await apiClient.get(`/client/medical-conditions/${client_id}/`);
  return response.data;
};

export const updateMedicalConditions = async ({ client_id, data }) => {
  if (!client_id) throw new Error("Client ID is required for update");
  const response = await apiClient.put(`/client/medical-conditions/${client_id}/`, data);
  return response.data;
};

export const getFlashMessage = async (client_id) => {
  if (!client_id) throw new Error("Client ID is required");
  const response = await apiClient.get(`/client/client/${client_id}/flash-message/`);
  return response.data;
};

export const updateFlashMessage = async ({ client_id, data }) => {
  if (!client_id) throw new Error("Client ID is required");
  
  const response = await apiClient.put(`/client/client/${client_id}/flash-message/`, data);
  return response.data;
};